import { render } from "./RegisterAgreement.vue?vue&type=template&id=8c2caf46"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/RegisterAgreement.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8c2caf46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8c2caf46', __exports__)) {
    api.reload('8c2caf46', __exports__)
  }
  
  module.hot.accept("./RegisterAgreement.vue?vue&type=template&id=8c2caf46", () => {
    api.rerender('8c2caf46', render)
  })

}


export default __exports__